import { SearchField } from '@bechtel/client-common';
import styled, { css } from 'styled-components';
import { TextFieldSize, IconSize, Box, Button } from '@bechtel/gds';
import { weekPlanHeaderHeight } from '../../weekplancard/styled';
import { Scalars } from '@bechtel/types';

interface BacklogHeaderContainerProps {
  isDisableHeader: boolean;
}

export const SearchFieldStyled = styled(SearchField).attrs({ size: TextFieldSize.SMALL, iconSize: IconSize.SMALL })`
  ${({ theme }) => css`
    border-color: ${theme.colors.grey[300]};
  `}
`;

export const BacklogHeaderContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  px: { sm: '400' },
  py: { sm: '500' },
})<BacklogHeaderContainerProps>`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  height: ${weekPlanHeaderHeight};
  ${(props) =>
    props.isDisableHeader &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const SeperatorStyled = styled(Box).attrs({
  mt: { sm: '400' },
  mb: { sm: '400' },
})`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.grey[300]};
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: Scalars['Boolean'];
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;
